<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
// import storage from './stroage/index'
export default {
  name: 'app',
  comments: {},
  data () {
    return {
    }
  },
  mounted () {
  },
  created () {
    document.body.removeChild(document.getElementById('Loading'))
  },
  methods: {
  }
}
</script>

<style lang="scss">
  @import "./assets/scss/reset.scss";
  #app{
    width: 100%;
  }
  .el-dialog{
    width: 400px!important;
    position: relative!important;
    top: 50%!important;
    left: 50%!important;
    transform: translate(-50%,-50%)!important;
    margin: 0!important;
    border-radius: 10px!important;
    margin-top: 0!important;
  }
  .el-dialog__body{
    text-align: center!important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue